export default "__VITE_ASSET__73b112a5__"